"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleGroup = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const rebass_1 = require("rebass");
const ToggleGroup = (props) => {
    return React.createElement(rebass_1.Flex, { className: "ab-Toggle-Group" }, props.children);
};
exports.ToggleGroup = ToggleGroup;
